/**
 * Rafting river corridors + commercial sections (orientation-grade).
 * Merged into europe-highlights by slug at runtime — not survey-grade GPS tracks.
 * Coordinates are [lng, lat] for riverLine; section endpoints use lat/lng fields.
 */
module.exports = {
  "rafting-soca": {
    facts: [
      { key: "Difficulty", value: "WW1–WW4 by section" },
      { key: "WW", value: "WW1–WW4" },
      { key: "Season", value: "Apr–Oct (spring high water)" },
      { key: "Base", value: "Bovec · Kobarid" },
    ],
    riverLine: [
      [13.6425, 46.3308],
      [13.6144, 46.3563],
      [13.5797, 46.3367],
      [13.5464, 46.3197],
      [13.4895, 46.3109],
      [13.4897, 46.3189],
      [13.4807, 46.3054],
      [13.4986, 46.2916],
      [13.5527, 46.28],
      [13.5861, 46.2483],
      [13.5469, 46.243],
    ],
    sections: [
      {
        id: "soca-family",
        name: "Family / panorama",
        start: { name: "Čezsoča", lat: 46.3197, lng: 13.5464 },
        end: { name: "Srpenica", lat: 46.2916, lng: 13.4986 },
        duration: "~1.5 h on water · 2.5–3 h trip",
        difficulty: "WW1–WW2",
        lengthKm: 8,
        notes: "Beginners, families, scenic emerald water.",
      },
      {
        id: "soca-classic",
        name: "Classic Bovec run",
        start: { name: "Boka", lat: 46.3189, lng: 13.4897 },
        end: { name: "Trnovo ob Soči", lat: 46.28, lng: 13.5527 },
        duration: "1.5–2 h on water · 2.5–3 h trip",
        difficulty: "WW2–WW4",
        lengthKm: 10,
        notes: "Most-booked commercial section; bigger in spring melt.",
      },
      {
        id: "soca-long",
        name: "Long valley",
        start: { name: "Log Čezsoški", lat: 46.3109, lng: 13.4895 },
        end: { name: "Trnovo ob Soči", lat: 46.28, lng: 13.5527 },
        duration: "3.5–4 h trip",
        difficulty: "WW2–WW4",
        lengthKm: 20,
        notes: "Longer commercial day; operators combine quieter + classic water.",
      },
      {
        id: "soca-expert",
        name: "Trnovo → Kobarid",
        start: { name: "Trnovo ob Soči", lat: 46.28, lng: 13.5527 },
        end: { name: "Kobarid (Napoleon Bridge)", lat: 46.2483, lng: 13.5861 },
        duration: "Varies · guided experts",
        difficulty: "WW4–WW5+",
        lengthKm: 8,
        notes: "Technical; rarely offered as a standard tourist trip.",
      },
    ],
  },
  "rafting-tara": {
    facts: [
      { key: "Difficulty", value: "WW2–WW4" },
      { key: "WW", value: "WW2–WW4" },
      { key: "Duration", value: "1–3 days typical" },
      { key: "Season", value: "Apr–Oct" },
    ],
    riverLine: [
      [19.1, 43.28],
      [19.18, 43.22],
      [19.25, 43.15],
      [19.32, 43.08],
      [19.38, 43.02],
    ],
    sections: [
      {
        id: "tara-day",
        name: "Day canyon",
        start: { name: "Splavište / Brštanovica area", lat: 43.22, lng: 19.18 },
        end: { name: "Šćepan Polje area", lat: 43.08, lng: 19.32 },
        duration: "~1 day on water",
        difficulty: "WW2–WW3",
        lengthKm: 18,
        notes: "Classic day raft through Europe’s deepest canyon corridor.",
      },
      {
        id: "tara-multi",
        name: "Multi-day canyon",
        start: { name: "Upper put-ins (varies)", lat: 43.28, lng: 19.1 },
        end: { name: "Lower take-outs toward Drina", lat: 43.02, lng: 19.38 },
        duration: "2–3 days",
        difficulty: "WW2–WW4",
        lengthKm: 40,
        notes: "Camp/lodge packages; water level changes character fast.",
      },
    ],
  },
  "rafting-ardeche": {
    facts: [
      { key: "Difficulty", value: "WW1–WW3" },
      { key: "WW", value: "WW1–WW3" },
      { key: "Season", value: "Apr–Oct" },
      { key: "Classic", value: "Vallon → St-Martin 32 km" },
    ],
    riverLine: [
      [4.38, 44.42],
      [4.42, 44.38],
      [4.48, 44.35],
      [4.55, 44.32],
      [4.62, 44.3],
    ],
    sections: [
      {
        id: "ardeche-gorges",
        name: "Gorges classic",
        start: { name: "Vallon-Pont-d'Arc area", lat: 44.405, lng: 4.39 },
        end: { name: "St-Martin-d'Ardèche area", lat: 44.3, lng: 4.62 },
        duration: "1–2 days · ~6–8 h paddling",
        difficulty: "WW1–WW3",
        lengthKm: 32,
        notes: "Pont d'Arc + canyon camps; book put-in slots in peak summer.",
      },
    ],
  },
  "czech-vltava": {
    facts: [
      { key: "Difficulty", value: "WW1–WW2" },
      { key: "WW", value: "WW1–WW2" },
      { key: "Season", value: "May–Sep" },
      { key: "Base", value: "Vyšší Brod · Český Krumlov" },
    ],
    riverLine: [
      [14.3117, 48.6167],
      [14.367, 48.655],
      [14.34, 48.72],
      [14.3152, 48.8106],
      [14.34, 48.835],
      [14.37, 48.854],
    ],
    sections: [
      {
        id: "vltava-vyssi-krumlov",
        name: "Vyšší Brod → Český Krumlov",
        start: { name: "Vyšší Brod", lat: 48.6167, lng: 14.3117 },
        end: { name: "Český Krumlov", lat: 48.8106, lng: 14.3152 },
        duration: "1–2 days · popular multi-stage",
        difficulty: "WW1–WW2",
        lengthKm: 35,
        notes: "Classic South Bohemian raft/canoe corridor; weirs + camps.",
      },
      {
        id: "vltava-krumlov-day",
        name: "Krumlov day stretch",
        start: { name: "Above Český Krumlov", lat: 48.78, lng: 14.32 },
        end: { name: "Zlatá Koruna area", lat: 48.854, lng: 14.37 },
        duration: "~4–6 h trip",
        difficulty: "WW1–WW2",
        lengthKm: 12,
        notes: "Shorter town-to-monastery day for first-timers.",
      },
    ],
  },
  "rafting-cetina": {
    facts: [
      { key: "Difficulty", value: "WW2–WW3" },
      { key: "WW", value: "WW2–WW3" },
      { key: "Season", value: "Apr–Oct" },
      { key: "Base", value: "Omiš / Zadvarje" },
    ],
    riverLine: [
      [16.78, 43.42],
      [16.74, 43.43],
      [16.7, 43.445],
      [16.68, 43.444],
    ],
    sections: [
      {
        id: "cetina-gorge",
        name: "Cetina canyon classic",
        start: { name: "Zadvarje / upper put-in", lat: 43.42, lng: 16.78 },
        end: { name: "Lower gorge take-out", lat: 43.444, lng: 16.68 },
        duration: "~2–3 h on water",
        difficulty: "WW2–WW3",
        lengthKm: 8,
        notes: "Karst canyon day near Omiš; spring melt is punchier.",
      },
    ],
  },
  "rafting-salza": {
    facts: [
      { key: "Difficulty", value: "WW2–WW3" },
      { key: "WW", value: "WW2–WW3" },
      { key: "Season", value: "Apr–Sep" },
      { key: "Base", value: "Wildalpen / Palfau" },
    ],
    riverLine: [
      [14.98, 47.66],
      [14.94, 47.68],
      [14.9, 47.7],
      [14.86, 47.72],
    ],
    sections: [
      {
        id: "salza-classic",
        name: "Salza alpine run",
        start: { name: "Upper Salza put-in", lat: 47.66, lng: 14.98 },
        end: { name: "Palfau / lower take-out", lat: 47.72, lng: 14.86 },
        duration: "~2–3 h on water",
        difficulty: "WW2–WW3",
        lengthKm: 12,
        notes: "Clear Styrian water; commercial half-days common.",
      },
    ],
  },
  "rafting-noguera": {
    facts: [
      { key: "Difficulty", value: "WW2–WW4 by section" },
      { key: "WW", value: "WW2–WW4" },
      { key: "Season", value: "Apr–Oct" },
      { key: "Base", value: "Llavorsí · Sort" },
    ],
    riverLine: [
      [1.22, 42.48],
      [1.21, 42.46],
      [1.17, 42.44],
      [1.13, 42.41],
    ],
    sections: [
      {
        id: "noguera-llavorsi",
        name: "Llavorsí classic",
        start: { name: "Llavorsí", lat: 42.46, lng: 1.21 },
        end: { name: "Rialp / mid valley", lat: 42.44, lng: 1.17 },
        duration: "~1.5–2 h on water",
        difficulty: "WW2–WW3",
        lengthKm: 8,
        notes: "Catalonia’s most booked whitewater corridor.",
      },
      {
        id: "noguera-sort",
        name: "Toward Sort",
        start: { name: "Rialp area", lat: 42.44, lng: 1.17 },
        end: { name: "Sort", lat: 42.41, lng: 1.13 },
        duration: "~1–1.5 h",
        difficulty: "WW2–WW4",
        lengthKm: 6,
        notes: "Operators often combine with the Llavorsí stretch.",
      },
    ],
  },
  "rafting-noce": {
    facts: [
      { key: "Difficulty", value: "WW2–WW4" },
      { key: "WW", value: "WW2–WW4" },
      { key: "Season", value: "Apr–Sep" },
      { key: "Base", value: "Val di Sole / Mezzana" },
    ],
    riverLine: [
      [10.74, 46.28],
      [10.8, 46.3],
      [10.9, 46.34],
      [11.0, 46.38],
    ],
    sections: [
      {
        id: "noce-sole",
        name: "Val di Sole run",
        start: { name: "Cusiano / Ossana area", lat: 46.28, lng: 10.74 },
        end: { name: "Mostizzolo bridge area", lat: 46.38, lng: 11.0 },
        duration: "~2–3 h on water",
        difficulty: "WW2–WW4",
        lengthKm: 14,
        notes: "Trentino commercial classic; dam releases shape the day.",
      },
    ],
  },
  "rafting-drina": {
    facts: [
      { key: "Difficulty", value: "WW1–WW3" },
      { key: "WW", value: "WW1–WW3" },
      { key: "Season", value: "May–Sep" },
      { key: "Base", value: "Bajina Bašta · Perućac" },
    ],
    riverLine: [
      [19.28, 43.88],
      [19.32, 43.92],
      [19.35, 43.95],
      [19.38, 43.98],
    ],
    sections: [
      {
        id: "drina-perucac",
        name: "Perućac corridor",
        start: { name: "Upper Drina put-in", lat: 43.88, lng: 19.28 },
        end: { name: "Bajina Bašta / Perućac area", lat: 43.98, lng: 19.38 },
        duration: "~2–4 h trip",
        difficulty: "WW1–WW3",
        lengthKm: 15,
        notes: "Scenic Bosnia–Serbia border water; popular summer raft days.",
      },
    ],
  },
  "rafting-enns": {
    facts: [
      { key: "Difficulty", value: "WW2–WW3" },
      { key: "WW", value: "WW2–WW3" },
      { key: "Season", value: "Apr–Sep" },
      { key: "Base", value: "Admont / Gesäuse" },
    ],
    riverLine: [
      [14.45, 47.58],
      [14.35, 47.56],
      [14.25, 47.55],
      [14.18, 47.54],
    ],
    sections: [
      {
        id: "enns-gesaeuse",
        name: "Gesäuse stretch",
        start: { name: "Upper Enns put-in", lat: 47.58, lng: 14.45 },
        end: { name: "Admont / lower take-out", lat: 47.54, lng: 14.18 },
        duration: "~2–3 h on water",
        difficulty: "WW2–WW3",
        lengthKm: 12,
        notes: "Alpine park corridor; book with local Gesäuse operators.",
      },
    ],
  },
  "rafting-isere": {
    facts: [
      { key: "Difficulty", value: "WW2–WW4" },
      { key: "WW", value: "WW2–WW4" },
      { key: "Season", value: "Apr–Sep" },
      { key: "Base", value: "Bourg-d'Oisans / Romanche" },
    ],
    riverLine: [
      [6.12, 45.02],
      [6.05, 45.05],
      [5.98, 45.08],
      [5.92, 45.1],
    ],
    sections: [
      {
        id: "romanche-oisans",
        name: "Romanche / Oisans",
        start: { name: "Upper Romanche put-in", lat: 45.02, lng: 6.12 },
        end: { name: "Bourg-d'Oisans area", lat: 45.1, lng: 5.92 },
        duration: "~2 h on water",
        difficulty: "WW2–WW4",
        lengthKm: 10,
        notes: "Alps whitewater near ski-town logistics; spring melt recommended.",
      },
    ],
  },
  "rafting-aoos": {
    facts: [
      { key: "Difficulty", value: "WW2–WW4" },
      { key: "WW", value: "WW2–WW4" },
      { key: "Season", value: "Mar–Jun best" },
      { key: "Base", value: "Konitsa" },
    ],
    riverLine: [
      [20.7, 40.05],
      [20.65, 40.08],
      [20.6, 40.1],
      [20.55, 40.12],
    ],
    sections: [
      {
        id: "aoos-konitsa",
        name: "Aoos gorge (Konitsa)",
        start: { name: "Upper Aoos put-in", lat: 40.05, lng: 20.7 },
        end: { name: "Konitsa bridge area", lat: 40.12, lng: 20.55 },
        duration: "~2–3 h on water",
        difficulty: "WW2–WW4",
        lengthKm: 10,
        notes: "Wild Pindus gorge; guided trips preferred — remote take-outs.",
      },
    ],
  },
  "rafting-inn-otz": {
    facts: [
      { key: "Difficulty", value: "WW2–WW4" },
      { key: "WW", value: "WW2–WW4" },
      { key: "Season", value: "May–Sep" },
      { key: "Base", value: "Sölden / Ötztal" },
    ],
    riverLine: [
      [11.0, 46.97],
      [10.97, 47.02],
      [10.93, 47.08],
      [10.9, 47.15],
    ],
    sections: [
      {
        id: "otztal-inn",
        name: "Ötztal whitewater",
        start: { name: "Upper Ötztal put-in", lat: 46.97, lng: 11.0 },
        end: { name: "Ötz / lower valley", lat: 47.15, lng: 10.9 },
        duration: "~2–3 h on water",
        difficulty: "WW2–WW4",
        lengthKm: 16,
        notes: "Tirol commercial runs fed by glacier melt; levels change daily.",
      },
    ],
  },
  "france-verdon-hub": {
    facts: [
      { key: "Difficulty", value: "WW2–WW3 (raft days)" },
      { key: "WW", value: "WW2–WW3" },
      { key: "Season", value: "Apr–Sep" },
      { key: "Base", value: "Castellane · Moustiers" },
    ],
    riverLine: [
      [6.52, 43.85],
      [6.48, 43.8],
      [6.42, 43.76],
      [6.35, 43.75],
    ],
    sections: [
      {
        id: "verdon-castellane",
        name: "Castellane corridor",
        start: { name: "Castellane / upper Verdon", lat: 43.85, lng: 6.52 },
        end: { name: "Point Sublime / mid-gorge", lat: 43.75, lng: 6.35 },
        duration: "~half-day on water",
        difficulty: "WW2–WW3",
        lengthKm: 12,
        notes: "Orientation for Verdon raft days — also a climbing/trail hub.",
      },
    ],
  },
};
